import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { AdjustmentMiniEntity } from '../../domain/entities/AdjustmentMiniEntity'

export class AdjustmentMiniModel extends AdjustmentMiniEntity {
  constructor(dataDto: {
    id?: number
    amount?: number
    type?: AdjustmentMiniEntity['type']
    adjustmentReasonId?: number | null
    reason?: string | null
    note?: string | null
    effectiveDate?: string
    driverFullName?: string | null
    driverWorkingPhoneNumber?: string | null
  }) {
    super()
    mapEntityProperties<AdjustmentMiniModel>(this, dataDto, {
      map: {
        adjustmentReasonId: dataDto.adjustmentReasonId,
        adjustmentReasonName: dataDto.reason
      }
    })
  }
}
